module.exports = __webpack_public_path__ + "assets/8f68cbc695a65b356d24fadada6b69f2.svg";